var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompany24Line = function SvgIconCompany24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 10.15h-1.35V7.3a2.65 2.65 0 0 0-2.65-2.65H7.3A2.65 2.65 0 0 0 4.65 7.3v9.4a2.655 2.655 0 0 0 2.65 2.65h9.4a2.655 2.655 0 0 0 2.65-2.65v-3.9a2.65 2.65 0 0 0-2.65-2.65ZM6.35 16.7V7.3a.95.95 0 0 1 .95-.95h5.4a.95.95 0 0 1 .95.95v10.35h-2.8V15h-1.7v2.65H7.3a.95.95 0 0 1-.95-.95Zm11.3 0a.95.95 0 0 1-.95.95h-1.35v-5.8h1.35a.95.95 0 0 1 .95.95v3.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 7.9h-3.5v1.7h3.5V7.9ZM11.75 11.15h-3.5v1.7h3.5v-1.7Z"
  })));
};
export default SvgIconCompany24Line;